module.exports = __webpack_public_path__ + "img/logo.664c5ebb.png";